import ChatAction from "@/chatbot-library/ChatAction"

class ChatCheckboxes extends ChatAction {
  get name() {
    return "checkboxes"
  }

  getResponseContent(value) {
    let options = this.data.options
    if (this.data.hasGroups) {
      options = Array.prototype.concat.apply([], options.map(optionGroup => optionGroup.options))
    }
    let filteredOptions = options.filter(option => value.includes(option.id))
    return filteredOptions.length ? filteredOptions.map(option => option.label).join(", ") : ""
  }
}

export default ChatCheckboxes
